import http from "./httpService";
export default async function getCustomloginDetailsByIp(ipAddress: string,tenantcode:string){
    try {
        const res = await http.get(`/api/CustomerDetailsbyIP/CustomerDetailsbyIP?ipaddress=${ipAddress}&customer_code=${tenantcode}`);
        return res.data?.data[0][0];
    } catch(err) {
        console.log(err);
    }
}

